import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { SubtractDown, SubtractRed } from '../../../assets/images/web-isn';
import { useRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
function MenuServicedOfficeComponent() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrollUp, setIsScrollUp] = useState(false);
  const prevScrollY = useRef(0);
  const { language } = useParams();
  const menuItems = [
    {
      to: `/serviced-office/overview/`,
      name: t('servicedOffice.label_overview'),
      active: location.pathname.includes(`/serviced-office/overview`),
    },
    {
      name: t('servicedOffice.label_types'),
      active: location.pathname.includes(`/serviced-office/types`),
    },
    {
      to: `/serviced-office/location/`,
      name: t('servicedOffice.label_location'),
      active: location.pathname.includes(`/serviced-office/location`),
    },
    {
      to: `/serviced-office/gallery/`,
      name: t('servicedOffice.label_gallery'),
      active: location.pathname.includes(`/serviced-office/gallery`),
    },
  ];

  const subMenu = [
    {
      to: `/serviced-office/types/private-room/`,
      name: t('servicedOffice.label_privateRoom'),
      active: location.pathname.includes(`/serviced-office/types/private-room/`),
    },
    {
      to: `/serviced-office/types/work-space/`,
      name: t('servicedOffice.label_workSpace'),
      active: location.pathname.includes(`/serviced-office/types/work-space/`),
    },
    {
      to: `/serviced-office/types/virtual-offices/`,
      name: t('servicedOffice.label_virtualOffices'),
      active: location.pathname.includes(`/serviced-office/types/virtual-offices/`),
    },
    {
      to: `/serviced-office/types/meeting-room/`,
      name: t('servicedOffice.label_meetingRoom'),
      active: location.pathname.includes(`/serviced-office/types/meeting-room/`),
    },
  ];

  const DropdownMenu = () => {
    return (
      <ul className={language === 'jp' ? 'dropdown-menu dropdown-menu-jp' : 'dropdown-menu'}>
        {subMenu.map((item, index) => (
          <li key={index}>
            {
              <Link to={`/${language}` + item.to} className={`${item.active ? 'active_item' : ''}`}>
                {item.name}
              </Link>
            }
          </li>
        ))}
      </ul>
    );
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    prevScrollY.current >= 395 ? setIsScrollUp(true) : setIsScrollUp(false);
    prevScrollY.current = currentScrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [prevScrollY]);

  return (
    <div id="servicedOfficeMenu" className={`${isScrollUp ? 'servicedOffice' : 'servicedOfficeHide'}`}>
      <div className="container">
        <div className="row scroll-menu px-3 pt-3">
          <ul className="d-flex" style={{ position: 'relative' }}>
            {menuItems.map((item, index) => (
              <li key={index}>
                {item.name === t('servicedOffice.label_types') ? (
                  <>
                    <div
                      className={`serviced-office-menu-item right-space ${
                        item.active ? 'active_item' : ''
                      } types-menu-hover pb-3`}
                    >
                      {item.name}
                      <img src={item.active ? SubtractRed : SubtractDown} alt="icon" style={{ padding: '5px' }}></img>
                      <DropdownMenu />
                    </div>
                  </>
                ) : (
                  <Link
                    to={`/${language}` + item.to}
                    className={`serviced-office-menu-item right-space ${item.active ? 'active_item' : ''}`}
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MenuServicedOfficeComponent;
